import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowBottomItemFirstProps as Props } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';
import { showRecruitmentPageRelatedRecruitments } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [applications, setApplications] = useState<Recruitment[]>([])

  useEffect(() => {
    const request = async () => {
      try {
        const response = await showRecruitmentPageRelatedRecruitments(props.recruitmentId);
        setApplications(response.recruitments);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.recruitmentId]);

  useEffect(() => {
    const $slider = $('.js-recruitment-bottom-first')
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        prevArrow: '<div class="recruitment__show__applications__slider--prev"></div>',
        nextArrow: '<div class="recruitment__show__applications__slider--next"></div>',
        responsive: [
          {
            breakpoint: 1050,
            settings: {
              arrows: false
            }
          }
        ]
      })
    }
  }, [applications])

  return (
    <Presentation
      {...props}
      applications={applications}
    />
  );
};
